/**
 * Normalize avatar paths from the API for browser <img> tags.
 * Stored URLs are always relative (/api/uploads/avatars/...) so they work
 * through the dev proxy, nginx, or Traefik on the same host.
 */
export function resolveAvatarUrl(src) {
  if (!src || typeof src !== 'string') {
    return null;
  }

  const trimmed = src.trim();
  if (!trimmed) {
    return null;
  }

  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  if (trimmed.startsWith('/api/')) {
    return trimmed;
  }

  if (trimmed.startsWith('/uploads/avatars/')) {
    return `/api${trimmed}`;
  }

  if (trimmed.startsWith('uploads/avatars/')) {
    return `/api/${trimmed}`;
  }

  if (trimmed.startsWith('/')) {
    return trimmed;
  }

  return `/api/uploads/avatars/${trimmed.replace(/^\/+/, '')}`;
}
